import Cookies from 'js-cookie'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SetCookie = (cookiename: string, value: any) => {
  const isProduction = import.meta.env.VITE_BASE_SERVER === 'production'
  Cookies.set(cookiename, value, {
    expires: 1, // 1day
    secure: isProduction ? true : false,
    sameSite: isProduction ? 'strict' : 'lax',
  })
}
export const GetCookie = (cookiename: string) => Cookies.get(cookiename)
export const RemoveCookie = (cookiename: string) => Cookies.remove(cookiename)
